import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip/Tooltip';
import MuiTooltip from '@mui/material/Tooltip/Tooltip';

export type TooltipProps = MuiTooltipProps;

export const Tooltip = MuiTooltip;
